$(document).ready(function(){
  var main_title = document.title;
  var title_array = [shop_config.meta_title_alt, main_title ];
  var i = 0;

  var hidden, state, visibilityChange; 
  if (typeof document.hidden !== "undefined") {
    hidden = "hidden";
    visibilityChange = "visibilitychange";
    state = "visibilityState";
  } else if (typeof document.mozHidden !== "undefined") {
    hidden = "mozHidden";
    visibilityChange = "mozvisibilitychange";
    state = "mozVisibilityState";
  } else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
    state = "msVisibilityState";
  } else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
    state = "webkitVisibilityState";
  }

  // Add a listener that constantly changes the title
  document.addEventListener(visibilityChange, function() {
    if( document[state] == 'hidden' ){
      // document.title = shop_config.meta_title_alt;
      (function mt_loop() {
        if( document[state] == 'hidden' ){
          if (i < (title_array.length - 1)) {
            document.title = title_array[i];
            i++;
          } else {
            title_array.reverse();
            i = 0;
            document.title = title_array[i];
            i = 1;
          }
        } else{
          document.title = main_title;
        }
        setTimeout(mt_loop, 1500);
      })();
    } else if( document[state] == 'visible' ){
      document.title = main_title;
    }
  }, false);

});